import { useTranslation } from "react-i18next";
import { NeuCard } from "../../components/neu/Neu";

// تجميعات تقرير العقوبات: بالسبب وبالفرع وبأعلى الموظفين.
export const PenaltyGroups = ({ data }) => {
  const { t } = useTranslation();
  const blocks = [
    ["penalty.report.byReason", data.by_reason],
    ["penalty.report.byBranch", data.by_branch],
    ["penalty.report.byEmployee", data.by_employee],
  ];

  return (
    <div className="grid gap-3 lg:grid-cols-3" data-testid="penalty-report-groups">
      {blocks.map(([key, rows]) => (
        <NeuCard key={key} inset className="grid gap-2 p-4">
          <p className="label-xs">{t(key)}</p>
          {rows.length ? (
            rows.map((row) => (
              <div key={row.key} className="flex items-center justify-between gap-2 text-xs">
                <span className="min-w-0 flex-1 truncate font-bold">{row.label || "—"}</span>
                <span className="num text-muted-foreground">{row.count}</span>
                <span className="num font-mono font-bold">{row.amount}</span>
              </div>
            ))
          ) : (
            <p className="text-xs text-muted-foreground">{t("penalty.report.noGroup")}</p>
          )}
        </NeuCard>
      ))}
    </div>
  );
};
